import { useSubscribeLink } from "@helper/checkMobileAppLink";
import { List, ListItem } from "@sphtech/sph-web-ui/elements/List";
import cx from "classnames";
import React from "react";

import { FooterMenuDetails } from "./footerMenuConstants";
import { FooterMenuType } from "./footerMenuType";

type FooterMenuListProps = {
  testId: string;
  items: FooterMenuDetails[];
  type: FooterMenuType;
};

export function FooterMenuList({ testId, items, type }: FooterMenuListProps) {
  const subLink = useSubscribeLink();

  const listStyle = cx(
    "text-text-inverse",
    type === "social" && "flex items-center lg:-mt-[10px]",
    type === "top" && "[&_a]:font-regular",
    type === "eshop" && "[&_a]:font-bold",
    type === "appDownload" && "flex gap-[12px]",
  );

  return (
    <List testId={`${testId}-${type}-footerMenuList`} className={listStyle}>
      {items.map((item: FooterMenuDetails, index: number) => (
        <React.Fragment key={index}>
          {!(subLink === "" && item.title === "Langgan") && (
            <>
              <ListItem
                key={`${testId}-item-${index}`}
                testId={`${testId}-item-${index}`}
              >
                <a
                  key={index}
                  href={item.url}
                  target={item.newTab ? "_blank" : "_self"}
                  rel="noopener noreferrer"
                  className={cx(
                    "text-xs font-primary lead-[150%] font-light hover:underline",
                    type === "social" &&
                      index === 5 &&
                      "p-1.5 flex justify-end",
                  )}
                >
                  {item.title ? item.title : null}
                  {item.images ? (
                    <img
                      src={item.images}
                      alt={`${item.title || item.alt}-menu-icon`}
                    />
                  ) : null}
                </a>
              </ListItem>
            </>
          )}
        </React.Fragment>
      ))}
    </List>
  );
}
